  import { createModalStore } from '@/shared/lib/modal';

/**
 * Open/close singleton for the Book-a-Call modal. Lives in the entity layer (not the feature) so the
 * onboarding survey can open it on a qualified submit without a feature→feature import (FSD).
 */
export const useBookACallStore = createModalStore();
